// DEV
// export const ServerURL = "http://rewire-cyberability-platform.local/"
// export const ServerURL = "http://localhost/"
// export const SaveVisitorStats = false

// PROD
export const ServerURL = "https://cyberability-platform.informacni-bezpecnost.cz/data/"
export const SaveVisitorStats = true